document.addEventListener("visitorConsentCollected", function () {
  // check if shopify is loaded and customer privacy is available
  if (!window.Shopify || !window.Shopify.customerPrivacy) return;

  // Only run if marketing consent is granted (ad_storage equivalent)
  if (window.Shopify.customerPrivacy.marketingAllowed()) {
    dwInitGclidRestore();
  }
});

function dwInitGclidRestore() {
  const COOKIE_NAME = "_gcl_aw";
  const COOKIE_NAME_P = "GCL_AW_P";
  const CLICK_PARAM = "lnid";
  const MAX_AGE = 90 * 24 * 60 * 60; // 90 days in seconds

  // Get current URL
  const url = window.location.href;

  // Check if HTTPS
  const isHttps = url.indexOf("https://") === 0;

  // Cookie options
  const COOKIE_OPTIONS = {
    domain: "auto",
    path: "/",
    maxAge: MAX_AGE,
    sameSite: "Lax",
    secure: isHttps,
  };

  // Helper function to check if URL parameter exists
  function hasParam(name) {
    if (!url) return false;
    const q = url.indexOf("?");
    if (q === -1) return false;
    const query = url.substring(q + 1);
    return ("&" + query).indexOf("&" + name + "=") !== -1;
  }

  // Helper function to get URL parameter value
  function getParamRaw(name) {
    if (!url) return null;
    const q = url.indexOf("?");
    if (q === -1) return null;
    const query = url.substring(q + 1);
    const parts = query.split("&");
    for (let i = 0; i < parts.length; i++) {
      const kv = parts[i].split("=");
      if (kv[0] === name) return kv.length > 1 ? kv[1] : "";
    }
    return null;
  }

  // Helper function to build timestamp seed
  function buildSeedTs() {
    const tsSecRounded = ((Date.now() + 500) / 1000) | 0;
    return "GCL." + tsSecRounded;
  }

  // Helper function to get cookie value
  function getCookieValue(name) {
    const nameEQ = name + "=";
    const ca = document.cookie.split(";");
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) === " ") c = c.substring(1, c.length);
      if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
  }

  // Helper function to set cookie
  function setCookie(name, value, options) {
    let cookieString = name + "=" + value;

    if (options.path) cookieString += "; path=" + options.path;
    if (options.maxAge) cookieString += "; max-age=" + options.maxAge;
    if (options.sameSite) cookieString += "; samesite=" + options.sameSite;
    if (options.secure) cookieString += "; secure";

    // Handle domain setting
    if (options.domain && options.domain !== "auto") {
      cookieString += "; domain=" + options.domain;
    } else if (options.domain === "auto") {
      // Extract domain from current hostname
      const hostname = window.location.hostname;
      if (hostname.indexOf(".") !== -1) {
        const parts = hostname.split(".");
        if (parts.length >= 2) {
          const domain = "." + parts.slice(-2).join(".");
          cookieString += "; domain=" + domain;
        }
      }
    }

    document.cookie = cookieString;
  }

  // Helper function to write both cookies
  function writeCookies(value) {
    setCookie(COOKIE_NAME, value, COOKIE_OPTIONS);
    setCookie(COOKIE_NAME_P, value, COOKIE_OPTIONS);
  }

  // Core logic to create or append to cookie
  function maybeCreateOrAppend() {
    // Don't run if gclid parameter is present
    if (hasParam("gclid")) return;

    // Get the lnid parameter value
    const lnidRaw = getParamRaw(CLICK_PARAM);
    if (!lnidRaw) return;

    // Get existing cookie value
    const existing = getCookieValue(COOKIE_NAME) || "";

    if (!existing) {
      // Create new cookies with timestamp seed and lnid
      const newValue = buildSeedTs() + "." + lnidRaw;
      writeCookies(newValue);
      return;
    }

    // Check existing cookie structure
    const firstDot = existing.indexOf(".");
    const secondDot = firstDot === -1 ? -1 : existing.indexOf(".", firstDot + 1);

    if (secondDot === -1) {
      // Append lnid to existing cookie value
      const newValue = existing + "." + lnidRaw;
      writeCookies(newValue);
    }
  }

  try {
    maybeCreateOrAppend();
  } catch (e) {
    // Handle errors silently
  }
}